package com.example.positionahead.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp

private val PremiumGreen = Color(0xFF00C805)
private val PremiumRed = Color(0xFFFF5000)
private val DeepNavy = Color(0xFF0A0F1E)
private val SurfaceDark = Color(0xFF0D1117)
private val SurfaceLight = Color(0xFFF8FAFC)
private val TextPrimaryLight = Color(0xFF1E293B)
private val TextSecondaryLight = Color(0xFF64748B)

private val LightColors = lightColorScheme(
    primary = PremiumGreen,
    onPrimary = Color.White,
    primaryContainer = Color(0xFFF0FDF4),
    secondary = DeepNavy,
    onSecondary = Color.White,
    background = SurfaceLight,
    surface = Color.White,
    onBackground = TextPrimaryLight,
    onSurface = TextPrimaryLight,
    onSurfaceVariant = TextSecondaryLight,
    error = PremiumRed,
    outline = Color(0xFFE2E8F0),
)

private val DarkColors = darkColorScheme(
    primary = PremiumGreen,
    onPrimary = Color.Black,
    primaryContainer = Color(0xFF064E3B),
    secondary = Color(0xFF94A3B8),
    onSecondary = Color.Black,
    background = DeepNavy,
    surface = SurfaceDark,
    onBackground = Color(0xFFF1F5F9),
    onSurface = Color(0xFFF1F5F9),
    onSurfaceVariant = Color(0xFF94A3B8),
    error = PremiumRed,
    outline = Color(0xFF334155),
)

val gainColor @Composable get() = PremiumGreen
val lossColor @Composable get() = PremiumRed

private val AppTypography = Typography(
    headlineMedium = TextStyle(fontWeight = FontWeight.Bold, fontSize = 26.sp, letterSpacing = (-0.5).sp),
    titleMedium = TextStyle(fontWeight = FontWeight.SemiBold, fontSize = 18.sp),
    titleSmall = TextStyle(fontWeight = FontWeight.SemiBold, fontSize = 16.sp),
    bodyMedium = TextStyle(fontSize = 15.sp, lineHeight = 22.sp),
    bodySmall = TextStyle(fontSize = 13.sp, lineHeight = 18.sp),
    labelLarge = TextStyle(fontWeight = FontWeight.Medium, fontSize = 13.sp),
)

@Composable
fun PositionAheadTheme(content: @Composable () -> Unit) {
    MaterialTheme(
        colorScheme = LightColors,
        typography = AppTypography,
        content = content,
    )
}
